import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row } from 'react-bootstrap';
import Testimonials from '../../common/Testimonials/Testimonials';
import { theme } from '../../../../../themes';

class ShsTestimonials extends Component {
  render() {
    return (
      <div className="ShsTestimonialsContainer" style={{ backgroundColor: theme.colors.featureSection1 }}>
        <Grid>
          <Row>
            {/* <Col xs={12} sm={12} md={12} lg={12}> */}
            <Testimonials title="Testimonials" />
            {/* </Col> */}
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShsTestimonials);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/ShsTestimonials/ShsTestimonials.js